var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"merchant-logo",style:(_vm.logoStyle),attrs:{"tabindex":"-1"}},[(_vm.hasLogo)?[_c('img',{attrs:{"src":_vm.merchantLogo,"alt":"","tabindex":"-1"}})]:[_vm._v("\n        "+_vm._s(_vm.merchantTextLogo)+"\n    ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }